import { ActorLayoutVariant } from "features/new-actor/enums/actorLayoutVariant";
import { PersonalInformationFieldNames } from "features/new-actor/enums/personalInformationFieldNames";
import { NaturalPersonFormValues } from "features/new-actor/types/naturalPersonFormValues";
import { LayoutFieldsDisabledRulesType, LayoutFieldsDisplayRulesType } from "types/form/layoutFieldRules";
import { LayoutFieldRulesNames } from "./layoutConfig";

export type NaturalPersonDisplayRules = LayoutFieldsDisplayRulesType<ActorLayoutVariant, LayoutFieldRulesNames>

export const naturalPersonLayoutFieldsDisplayRules: NaturalPersonDisplayRules = {
  [ActorLayoutVariant.BorrowerActors]: {
    [PersonalInformationFieldNames.BirthDate]: {
      add: true,
      edit: true,
    },
  },
  [ActorLayoutVariant.DefaultActor]: {
    [PersonalInformationFieldNames.BirthDate]: {
      add: true,
      edit: true,
    },
  },
  [ActorLayoutVariant.InsuredActor]: {
    [PersonalInformationFieldNames.BirthDate]: {
      add: true,
      edit: true,
    },
  },
  [ActorLayoutVariant.NaturalPerson]: {
    [PersonalInformationFieldNames.BirthDate]: {
      add: true,
      edit: true,
    },
  },
  [ActorLayoutVariant.UnemploymentActor]: {
    [PersonalInformationFieldNames.BirthDate]: {
      add: true,
      edit: true,
    },
  },
}

export const naturalPersonDisabledFields: Array<keyof NaturalPersonFormValues> = [
  PersonalInformationFieldNames.LastName,
  PersonalInformationFieldNames.FirstName,
  PersonalInformationFieldNames.Civility,
];

export type NaturalPersonDisabledRules = LayoutFieldsDisabledRulesType<ActorLayoutVariant, keyof NaturalPersonFormValues>

export const naturalPersonLayoutFieldsDisabledRules: NaturalPersonDisabledRules = {
  [ActorLayoutVariant.DefaultActor]: naturalPersonDisabledFields,
  [ActorLayoutVariant.InsuredActor]: naturalPersonDisabledFields,
  [ActorLayoutVariant.NaturalPerson]: naturalPersonDisabledFields
}
